import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';
import { SearchFacetOptions } from '#server/models';
import { CourseResults, ResultsMain } from '@/components';
import { RumClient } from '@/services';

const paramsSchema = z.object({
  facet: z.enum(SearchFacetOptions),
});

const ResultsWrapper = () => {
  const { facet } = useParams({ from: '/results/$facet' });
  return facet === 'courses' ? <CourseResults /> : <ResultsMain />;
};

export const Route = createFileRoute('/results/$facet')({
  params: {
    parse: (params) => {
      let result: z.infer<typeof paramsSchema>;
      try {
        result = paramsSchema.parse(params);
      } catch (error) {
        RumClient.recordError(error);
        throw new Error('Invalid facet');
      }
      return result;
    },
    stringify: (params) => params,
  },
  component: ResultsWrapper,
});
